import React, {useRef, useState, useContext} from 'react';
import {
    _t,
    customStyle,
    getCookie
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import Confetti from '../modal/Confetti';
//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";
import { FoodContext } from '../../../../contexts/Food';

const feebackOptions = [
    { id: "1", label: "satisfied", icon: "🙂" },
    { id: "2", label: "neutral", icon: "😐" },
    { id: "3", label: "unsatisfied", icon: "🙁" },
]; 

const feedbackCategory = [
    { id: "1", name: "Kitchen"},
    { id: "2", name: "Rider"},
    { id: "3", name: "Service"},
]

const reasonOptions = {
    "Kitchen":[
        { id: "1", name: "Foreign object"},
        { id: "2", name: "Wrong product"},
        { id: "3", name: "Instructions not followed" },
        { id: "4", name: "Missing item" },
        { id: "5", name: "Less topping" },
        { id: "6", name: "Product quality" },
        { id: "7", name: "Overcooked" },
        { id: "8", name: "Undercooked" },
        { id: "10", name: "pizza paste on box" },
        { id: "11", name: "smell in pizza" },
        { id: "12", name: "Others" },
    ],
    "Rider":[
        { id: "1", name: "Late order" },
        { id: "2", name: "Cold product" },
        { id: "3", name: "Missing item" },
        { id: "4", name: "Staff behaviour" },
        { id: "5", name: "Wrong product" },
        { id: "6", name: "Pizza paste on box " },
        { id: "7", name: "Change not return" },
        { id: "8", name: "Change/Pos machine not carry" },
    ],
    "Service":[
        
        { id: "1", name: "Staff behaviour" },
        { id: "2", name: "Manager behaviour" },
        { id: "3", name: "Late order" },
        { id: "4", name: "Wrong product " },
        { id: "5", name: "Missing item " },
        { id: "6", name: "Ambiance not good" },
        { id: "7", name: "Ac not working" },
        { id: "8", name: "Instructions not followed" },
        { id: "9", name: "no response" },
        { id: "10", name: "Extra amount charged" },
    ]
};


const OrderFeebackModal = ({feedbackDetails,setFeedbackDetails}) => {
    const { t } = useTranslation();
    const {
        setLoading,
    } = useContext(FoodContext);
    const confettiFn = useRef(null);
    const [emoji, setEmoji] = useState("🙂");

     //feedback reason
     const handleFeedbackCategory = (category)=>{
        setFeedbackDetails((curr)=>({
            ...curr,
            category: category,
            reason:""
        }))
    }

    //feedback reason
    const handleFeedbackReason = (reason)=>{
        setFeedbackDetails((curr)=>({
            ...curr,
            reason:reason
        }))
    }
    const handleFeedbackChange = (e)=>{
        const target = e?.target;
        if (!target) return;
        const { name, value } = target;
        setFeedbackDetails((curr) => ({
            ...curr,
            [name]: value,
        }));
    }
    const handleCancelModal = () => {
        setFeedbackDetails({
            item: null,
            feedback: "",
            reason:"",
            category:"",
            desc: "",
            view: false,
            modal:false
        })
    }
    //submit feedback
    const handleFeebackSubmit = (e) => {
        e.preventDefault();
        if(!feedbackDetails.feedback){
            toast.error(`${_t(t("Please select feedback"))}`, {
                position: "bottom-center",
                closeButton: false,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
            });
            return
        }
        if(feedbackDetails.feedback === "unsatisfied" && !feedbackDetails.reason){
            toast.error(`${_t(t("Please select reason"))}`, {
                position: "bottom-center",
                closeButton: false,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
            });
            return
        }
        const url = BASE_URL + "/settings/customer-order-feedback";
        const formData = new FormData();
        formData.append("order_id", feedbackDetails.item.order_id);
        formData.append("order_date", feedbackDetails.item.order_date);
        formData.append("branch_id", feedbackDetails.item.branch_id);
        formData.append("customer_id", feedbackDetails.item?.customer_id || "");
        formData.append("customer_name", feedbackDetails.item?.customer_name || "");
        formData.append("token", feedbackDetails.item.token);
        formData.append("delivery_phn_no", feedbackDetails.item?.delivery_phn_no || "");
        formData.append("delivery_address", feedbackDetails.item?.delivery_address || "");
        formData.append("total_payable", feedbackDetails.item.total_payable);
        formData.append("feedback", feedbackDetails.feedback);
        formData.append("reason", (feedbackDetails?.category ? (feedbackDetails?.category?.name + " - ") : "" ) + (feedbackDetails.reason?.name || ""));
        formData.append("remarks", feedbackDetails.desc || "");
        setLoading(true);

        axios
        .post(url, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then(() => {
            setLoading(false);
            void confettiFn.current?.(3000);
            setFeedbackDetails({
                item: null,
                feedback: "",
                reason:"",
                category:"",
                desc: "",
                view: false,
                modal:false
            })
            toast.success(`${_t(t("Feeback Submited successfully"))}`, {
                position: "bottom-center",
                closeButton: false,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
            });
        })
        .catch(() => {
            setLoading(false);
            toast.error(`${_t(t("Please try again"))}`, {
                position: "bottom-center",
                closeButton: false,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
            });
        });
    }

    return (
        <>
        <Confetti
            emojis={[emoji]}
            time = {3000}
            count={30}
            onInit={(fn) => (confettiFn.current = fn)}
        />
        {
            feedbackDetails.modal && (
                <div
                    className={`modal fade ${feedbackDetails.modal ? "showing" : ""}`}
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-md" style={{ transform: "translate(0, 2rem)" }}>
                        <div className="modal-content" style={{ borderRadius: "1rem" }}>
                            <div className="modal-body py-4">
                                <div className="card card-body">
                                    {
                                        feedbackDetails.view ? (
                                            <div className='mt-3 mb-4 mx-4 d-flex flex-column'>
                                                <div className='mb-1 xslg-text text-capitalize'>Feedback: <span className='text-secondary'> {feedbackDetails.feedback}</span></div>
                                                {feedbackDetails.reason && <div className='mb-0 lg-text'>Reason: <span className='text-muted'>{feedbackDetails.reason}</span></div>}
                                                <div className='mb-0 lg-text'>Remarks: <span className='text-muted'>{feedbackDetails.desc}</span></div>
                                            </div>
                                        ) : (
                                            <>
                                                <h4 className='text-center'>{_t(t("How satisfied are you with this our service?"))}</h4>
                                                <div className='d-flex mb-3 mt-1 mx-2'>
                                                    {
                                                        feebackOptions && feebackOptions.map((option) => (
                                                            <div className={`feedback-card1 flex-grow-1 text-center cursor-pointer mx-3 rounded p-2 ${option.label === feedbackDetails.feedback ? "active" : ""}`} key={option.id} 
                                                                onClick={(e) => {
                                                                    setEmoji(option.icon);
                                                                    setFeedbackDetails({ ...feedbackDetails, feedback: option.label, reason: "" })
                                                                }}
                                                            >
                                                                <div title={option.label} className="customer-font-total">
                                                                    {option.icon} 
                                                                </div>
                                                                <div className='print-text text-capitalize'>
                                                                    {option.label}
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                                <div className='mb-3 mx-4'>
                                                    {
                                                        feedbackDetails?.feedback && feedbackDetails?.feedback === "unsatisfied" && (
                                                            <>
                                                                <Select
                                                                    menuPosition="absolute"
                                                                    options={feedbackCategory ? feedbackCategory : []}
                                                                    getOptionLabel={(option) => option.name}
                                                                    getOptionValue={(option) => option.id}
                                                                    className="sm-text mb-2"
                                                                    value={feedbackDetails?.category}
                                                                    isClearable
                                                                    onChange={handleFeedbackCategory}
                                                                    styles={customStyle}
                                                                    placeholder={_t(t("select category")) + ".."}
                                                                />
                                                                <Select
                                                                    menuPosition="absolute"
                                                                    options={feedbackDetails?.category ? reasonOptions[feedbackDetails.category?.name] : []}
                                                                    getOptionLabel={(option) => option.name}
                                                                    getOptionValue={(option) => option.id}
                                                                    className="sm-text pt-1"
                                                                    value={feedbackDetails?.reason}
                                                                    isClearable
                                                                    onChange={handleFeedbackReason}
                                                                    styles={customStyle}
                                                                    placeholder={_t(t("select reason")) + ".."}
                                                                />
                                                            </>
                                                            
                                                        )
                                                    }
                                                </div>
                                                <div className='mb-5 mx-4'>
                                                <textarea id="desc" name="desc" rows="2" className="form-control" placeholder='comments' value={feedbackDetails?.desc} onChange={(e) => handleFeedbackChange(e)}>
                                                </textarea>
                                                </div>
                                            </>
                                        )
                                    }
                                    <div className={`d-flex mb-3 ${feedbackDetails.view ? "justify-content-end" : "justify-content-center"}`}>
                                        <button style={{ backgroundColor: "#ebebeb", borderColor: "#ebebeb" }} className="btn btn-light mr-4 rounded-sm" onClick={()=>handleCancelModal()}>
                                            {_t(t("Cancel"))}
                                        </button>
                                        {
                                            !feedbackDetails.view && (
                                                <button
                                                    className="btn btn-primary rounded-sm"
                                                    onClick={(e) => handleFeebackSubmit(e)}
                                                >
                                                    {_t(t("Submit"))}
                                                </button>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>   
            )
        }
        </>
    )
}

export default OrderFeebackModal